/** This value dictates the amount of minutes in one unit of the board.
 * Tasks can only exist, increase or decrease in multiples of this time. */
export const TIME_UNIT_MINUTES = 15;
